
<!-- ============================================================== -->
<!-- Profile - style you can find in header.scss -->
<!-- ============================================================== -->

<!-- <button [matMenuTriggerFor]="exit" mat-raised-button class="headbtn btn1"> Fermeture</button>

<mat-menu #exit="matMenu">
  <button mat-menu-item (click)="logout()"   >  {{'logout' | translate}} <i [style.color] = "'green'" class="fas fa-power-off fa-spin fa-2x"></i></button>
  <button mat-menu-item (click)="closesession()" > {{'closesession' | translate}} <i [style.color] = "'red'" class="fas fa-power-off fa-1x"></i></button>
</mat-menu> -->

<!-- <button mat-button class=" m-r-20 hidden-sm-up"  mat-raised-button class="headbtn btn1" (click)="refreshtab()">{{'refresh' | translate}}</button> -->
<!-- <button mat-button class=" m-r-20 hidden-sm-up"  mat-raised-button class="headbtn btn1" (click)="closetab()">{{'close' | translate}}</button> -->

<!-- <button mat-button [matMenuTriggerFor]="options" style="margin-left: 20px !important;" color="warn" class=" m-r-20 hidden-sm-up" mat-raised-button class="headbtn">{{'language' | translate}}  </button> -->



<ng-container>
  <button [matMenuTriggerFor]="options" mat-icon-button class="m-r-5" > 
    <img src="assets/images/translate.png" alt="user" class="profile-pic">
   </button>
</ng-container>

<mat-menu #options="matMenu" >
  <button mat-menu-item (click)="changeLanguage('en')"><img src="./../../../../assets/images/english.jpg" alt="en" width="18px"> {{'english' | translate}} </button>
  <button mat-menu-item (click)="changeLanguage('fr')"><img src="./../../../../assets/images/french.jpg" alt="fr" width="18px"> {{'french' | translate}}</button>
</mat-menu>

<ng-container *ngIf="countlogs>0">
  <button [matMenuTriggerFor]="profile" mat-icon-button class="m-r-5" [matBadge]="countlogs" matBadgePosition="after" matBadgeColor="warn"> <ng-container *ngIf="picture ==null || picture ==''"><img src="assets/images/profile.jpg" alt="user" class="profile-pic"></ng-container>
    <ng-container *ngIf="picture !=null && picture !=''"><img [src]="picture" alt="user" class="profile-pic"></ng-container>
   </button>
</ng-container>



<ng-container *ngIf="countlogs==0">
  <button [matMenuTriggerFor]="profile" mat-icon-button class="m-r-5"> <ng-container *ngIf="picture ==null || picture ==''"><img src="assets/images/profile.jpg" alt="user" class="profile-pic"></ng-container>
    <ng-container *ngIf="picture !=null && picture !=''"><img [src]="picture" alt="user" class="profile-pic"></ng-container>
   </button>
</ng-container>

<mat-menu #profile="matMenu" class="mymegamenu">
    <!-- <button mat-menu-item>
        <mat-icon>settings</mat-icon> Settings </button> -->

    <button (click)="viewProfil()" mat-menu-item>
      <mat-icon>account_box</mat-icon> Profile 
    </button>
    
    <!-- <button mat-menu-item>
      <mat-icon>notifications_off</mat-icon> 
      Disable notifications 
    </button> -->

    <button mat-menu-item (click)="logout()">
      <mat-icon>exit_to_app</mat-icon> 
      {{'logout' | translate}} 
    </button>

    <button mat-menu-item (click)="closesession()">
      <mat-icon>logout</mat-icon> 
      {{'closesession' | translate}} 
    </button>

</mat-menu>

